import { StoreSchema } from '../../../../shared/config/storeConfig/StoreSchema'

export const selectCommonUsersAll = (state: StoreSchema) =>
    state.commonData.common.usersAll
